
















import Vue from 'vue'

export default Vue.extend({
  name: 'FacebookReauthModal',

  props: {
    permission: {
      type: String,
      required: true,
    },
  },
})
